import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { ShipmentWaybillForeignTradeState } from './shipment-waybill-foreign-trade.state';
import {
  ShipmentWaybillForeignTradeLoad,
  ShipmentWaybillForeignTradeSetInitialState,
} from './shipment-waybill-foreign-trade.actions';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common';
import { WaybillIdView } from '../../../../models';
import {
  ForeignTradeDocumentsFlowModel,
  ForeignTradeMainInformation,
  ForeignTradePendingDocument,
  WaybillForeignTrade,
} from '../../../../models/foreign-trade.model';

@Injectable({ providedIn: 'root' })
export class ShipmentWaybillForeignTradeFacade implements LoadDataFacade, SetInitialStateFacade {
  loaded$: Observable<boolean> = this.store.select(ShipmentWaybillForeignTradeState.getLoaded);
  foreignTrade$: Observable<WaybillForeignTrade> = this.store.select(ShipmentWaybillForeignTradeState.getForeignTrade);

  documents$: Observable<ForeignTradePendingDocument[]> = this.store.select(
    ShipmentWaybillForeignTradeState.getDocuments,
  );

  documentsFlow$: Observable<ForeignTradeDocumentsFlowModel[]> = this.store.select(
    ShipmentWaybillForeignTradeState.getDocumentsFlow,
  );

  mainInformation$: Observable<ForeignTradeMainInformation> = this.store.select(
    ShipmentWaybillForeignTradeState.getMainInformation,
  );

  constructor(private store: Store) {}

  loadAll(identifier: WaybillIdView): void {
    this.store.dispatch(new ShipmentWaybillForeignTradeLoad(identifier));
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentWaybillForeignTradeSetInitialState());
  }
}
